import React from 'react';
import { DateConst } from '../shared/consts';

var d = new Date();
var dayName = DateConst.days[d.getDay()];
var monthName = DateConst.months[d.getMonth()];
let date = dayName + ', ' + monthName + " " + d.getDate().toString() + ", " + d.getFullYear().toString();

const TodaysDate = () => (
    <span>
        {date}
    </span>
);

export default TodaysDate;


// WEBPACK FOOTER //
// ./src/components/shared/TodaysDate.js